import './HeaderNavbar.css';
import NavbarItem from "./sub/NavbarItem/NavbarItem.jsx";

export default function HeaderNavbar({dropdownData}) {




    return <div id='header-navbar'>
        {dropdownData.length > 0 && dropdownData.map((item, index) => {
            return <NavbarItem item={item} key={index}/>
        })}
    </div>;
}
